<template>
  <div class="category-list-box">
    <el-table :data="data" style="width: 100%" row-key="id" :default-expand-all="true">
      <el-table-column prop="id" label="ID" width="100" />
      <el-table-column prop="title" label="名称" />
      <el-table-column label="图标">
        <template slot-scope="scope">
          <img class="icon" :src="scope.row.icon" v-if="scope.row.icon"  alt="x"/>
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序" width="100" />
      <el-table-column prop="ctime" label="时间" width="200" />
      <el-table-column label="操作" width="300">
        <template slot-scope="scope">
          <span class="action" @click="showEdit(scope.row)">编辑</span>
          <span class="action" @click="remove(scope.row.id)">删除</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import Sortable from 'sortablejs'

export default {
  name: 'CategoryListComponent',
  props: {
    pageData: {
      type: Array,
      default: function () {
        return []
      }
    },
    handleRemove: {},
    needDrag: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      data: [],
      sortData: []
    }
  },
  mounted () {
    this.data = this.pageData
    this.needDrag && this.initDrop()
  },
  methods: {
    initDrop () {
      console.log('init drag')
      const tbody = document.querySelector('.el-table__body-wrapper tbody')
      const that = this

      Sortable.create(tbody, {
        onEnd ({ newIndex, oldIndex }) {
          let data = that.data.concat()
          const currRow = data.splice(oldIndex, 1)[0]
          data.splice(newIndex, 0, currRow)
          that.data = data
          that.processSort()
        }
      })
    },
    processSort () {
      this.sortData = []
      for (let i in this.data) {
        this.sortData.push({
          id: this.data[i].id,
          sort: i
        })
      }
      this.$emit('onSortChanged', this.sortData)
    },
    showEdit (data) {
      this.$emit('onCategoryEdit', data)
    },
    remove (id) {
      let that = this
      this.$confirm('删除当前分类？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.handleRemove && that.handleRemove({id: id})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped lang="less">

.pagination {
  margin-top: 20px;
  text-align: center;
}

.icon{
  width:36px;
  height:36px;
}

.action {
  color: #3a8ee6;
  padding: 0 5px;

  &:hover {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/category/CategoryListComponent.vue